/* initialization of the Cal.com widget */
import { Controller } from '@hotwired/stimulus';
import { themeColor } from '@/utils/theme';

export default class extends Controller {
  static values = {
    calcomOrigin: String,
  };

  connect() {
    const url = new URL(this.calcomOriginValue);

    /* eslint-disable */
    (function (C, A, L) {
      let p = function (a, ar) {
        a.q.push(ar);
      };
      let d = C.document;
      C.Cal =
        C.Cal ||
        function () {
          let cal = C.Cal;
          let ar = arguments;
          if (!cal.loaded) {
            cal.ns = {};
            cal.q = cal.q || [];
            d.head.appendChild(d.createElement('script')).src = A;
            cal.loaded = true;
          }
          if (ar[0] === L) {
            const api = function () {
              p(api, arguments);
            };
            const namespace = ar[1];
            api.q = api.q || [];
            typeof namespace === 'string'
              ? (cal.ns[namespace] = api) && p(api, ar)
              : p(cal, ar);
            return;
          }
          p(cal, ar);
        };
    })(window, new URL('/embed/embed.js', url).href, 'init');
    Cal('init', {
      origin: url.origin,
    });
    Cal('ui', {
      theme: 'light',
      styles: {
        branding: { brandColor: themeColor(this.element, 'primary-900') },
      },
      hideEventTypeDetails: true,
    });
    /* eslint-enable */
  }
}
